import React from "react";

import classes from "./SectionTitle.module.scss";

const SectionTitle = (props) => {
  let style = {
    color: "black",
    backgroundColor: "white"
  };
  if (props.colors) {
    style = {
      background: `linear-gradient(to right, ${props.colors.length > 1 ? props.colors.join(",") : [props.colors[0], props.colors[0]].join(",")})`
    };
  }
  return (
    <div className={classes.title} style={style}>
      {props.children}
    </div>
  );
};

export default SectionTitle;
